import { React, useState, useContext } from 'react';
import { AppContext } from '../../../services/AppContext';
import { useTranslation } from 'react-i18next';

const ImportCustomers = ({ closeModal }) => {
    const { t } = useTranslation();
    const { apiClient, notify } = useContext(AppContext);
    const [selectedFile, setSelectedFile] = useState('');

    const handleImportCustomers = async () => {
        try {
            const formData = new FormData();
            formData.append("file", selectedFile);

            const result = await apiClient.importCustomers(formData);

            if (result.hasErrors) {
                return;
            }

            notify(t('pages.customers.modals.importSuccess'), 'success');
            closeModal(true);
        } catch (error) {
            notify(error.message, 'error');
        }
    };

    const handleCancel = () => {
        closeModal(false);
        setSelectedFile('');
    };

    const handleChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type === "text/csv") {
            setSelectedFile(file);
        } else {
            notify(t('pages.customers.modals.invalidFile'), "error");
            event.target.value = ""; // Reset input if not CSV
        }
    };

    return (<div className="modal">
        <div className="modal-content">
            <h3>{t('pages.customers.modals.pickFile')}</h3>
            <input
                type="file"
                name="file"
                accept=".csv*"
                onChange={handleChange}
            />
            
            <div className='container'>
                <button className='mg-r-1 width-100p' onClick={() => handleImportCustomers()}>{t('pages.customers.modals.importButton')}</button>
                <button className='width-100p' onClick={handleCancel}>{t('pages.customers.modals.cancelButton')}</button>
            </div>
        </div>
    </div>
    )
};

export default ImportCustomers;